import { render, staticRenderFns } from "./scope76.vue?vue&type=template&id=048d15f2&scoped=true"
import script from "./scope76.vue?vue&type=script&lang=js"
export * from "./scope76.vue?vue&type=script&lang=js"
import style0 from "./scope76.vue?vue&type=style&index=0&id=048d15f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d15f2",
  null
  
)

export default component.exports